import { useEffect } from "react";
import AccueilCards from "../components/AccueilCards/AccueilCards";
import { useDispatch } from "react-redux";
import { fetchDashboard } from "../store/slices/dashboardSlice";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import ProjectsByStateBarPlot from "../components/Dashboard/ProjectsByStateBarPlot";
import { Card, Col, Row, Statistic, StatisticProps } from "antd";
import Title from "antd/es/typography/Title";
import ProjectsByTypeRealisationChart from "../components/Dashboard/ProjectsByTypeRealisationPieChart";
import CountUp from "react-countup";
import LatestVisitsTable from "../components/Dashboard/LatestVisitsTable";
import UpcomingAlertsTable from "../components/Dashboard/UpcomingAlertsTable";
import VisitorPerformanceChart from "../components/Dashboard/VisitorPerformanceChart";
import StackedBarChart from "../components/Dashboard/VisitorPerformanceChart";
import TranchesMap from "../components/Dashboard/TranchesMap";
import { BiBuildings } from "react-icons/bi";
import { TbHomeSearch } from "react-icons/tb";

function AccueilPage() {
  const dispatch = useDispatch();
  const { data } = useSelector((state: RootState) => state.dashboard);

  const formatter: StatisticProps["formatter"] = (value) => (
    <CountUp end={value as number} separator="," />
  );
  useEffect(() => {
    dispatch(fetchDashboard());
  }, []);

  useEffect(() => {
    localStorage.setItem("lastPage", window.location.pathname);
  }, []);
  

  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <Row
        gutter={[16, 16]}
        justify={"space-between"}
        style={{ width: "100%", padding: "20px" }}
      >
        <Col xs={24} sm={24} md={24} lg={16}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Card style={{ border: "2px solid #42005a" }}>
                <Statistic
                  title={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "#000" }}>Total des projets</span>
                      <BiBuildings
                        style={{ fontSize: "20px", fill: "#42005a" }}
                      />
                    </div>
                  }
                  value={data?.total_projects}
                  formatter={formatter}
                />
              </Card>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12}>
              <Card style={{ border: "2px solid #42005a" }}>
                <Statistic
                  title={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "#000" }}>Total des visites</span>
                      <TbHomeSearch
                        style={{ fontSize: "20px", color: "#42005a" }}
                      />
                    </div>
                  }
                  value={data?.total_visits}
                  precision={2}
                  formatter={formatter}
                />
              </Card>
            </Col>
          </Row>
          <Title style={{ marginTop: "20px" }} level={5}>
            Localisation des projets avec les tranches
          </Title>

          <TranchesMap tranches={data?.tranches} />
          <Title style={{ marginTop: "20px" }} level={5}>
            Dernières Visites effectuées
          </Title>
          <LatestVisitsTable data={data?.latest_visits} />
          <Title style={{ marginTop: "20px" }} level={5}>
            Prochaines Alertes
          </Title>
          <UpcomingAlertsTable data={data?.upcoming_alerts} />
        </Col>
        <Col xs={24} sm={24} md={24} lg={8}>
          {data && <ProjectsByStateBarPlot data={data.projects_by_state} />}
          {data && (
            <ProjectsByTypeRealisationChart
              data={data.projects_by_type_realisation}
            />
          )}
          {data && (
            <VisitorPerformanceChart
              visitor_performance={data.visitor_performance}
            />
          )}
        </Col>
      </Row>
    </div>
  );
}

export default AccueilPage;
